import React from 'react';
import {routes, images} from '../constants';
import {connect} from 'react-redux';
import {RouteActions} from '../actions';
import {Card, DynamicContent, DynamicImage} from '../components';

class ContactPage extends React.Component {

    componentDidMount() {
        this.props.dispatch(RouteActions.setAppState(routes.CONTACT));
    }

    render () {
        return (
            <div className="container" id="contact-page">
                <div className="row center-cols">
                    <div className="col-sm-8 page-header">
                        <h1 className="page-title">Contact Us</h1>
                    </div>
                </div>
                <div className="row center-cols">
                    <div className="col-sm-9">
                        <Card>
                            <DynamicImage isBackground={true} src={images.CONTACT_IMAGE} className="contact-image hidden-xs"/>
                            <div className="contact-content">
                                <DynamicContent>
                                    <p>
                                        For additional information on our state-of-the-art testing facility and testing capabilities, please contact us at:
                                    </p>
                                    <hr />
                                    <table className="medium-editor-table" width="100%">
                                        <tbody>
                                            <tr>
                                                <td>Telephone:</td>
                                                <td><b>1 (800) 637-8628</b></td>
                                            </tr>
                                            <tr>
                                                <td>Email:</td>
                                                <td><b>tslab@oil-services-lab.com</b></td>
                                            </tr>
                                            <tr>
                                                <td>Address:</td>
                                                <td><b>2200 James Savage Road <br />Midland, MI 48642, USA</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr />
                                </DynamicContent>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {appState: state.appState.currentRoute}
}

export default connect(select)(ContactPage);



// WEBPACK FOOTER //
// ./web-app/containers/contact.jsx